(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-close-mobile-menu]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const menu = button.closest('.mobile-menu');
        if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
      });
    });
    scope.querySelectorAll('[data-smart-back]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        try {
          const previous = new URL(document.referrer);
          if (previous.origin !== location.origin || previous.pathname === location.pathname || history.length < 2) return;
          event.preventDefault();
          history.back();
        } catch (_) { /* Use the link's collection or home fallback. */ }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
